// UUID 是 通用唯一识别码（Universally Unique Identifier）的缩写
export function generateUUID () {
  var d = new Date().getTime()
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    var r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x7 | 0x8)).toString(16)
  })
  return uuid
}

export function getProduct (name = 'connect', version = '1.0.0') {
  return {
    name,
    version,
    product: `${name}||version=${version}`
  }
}

export function getQueryObj (url) {
  if (!url) {
    return {}
  }
  var regRrl = /^[^?]+\?([\w\W]+)$/
  var regPara = /([^&=]+)=([\w\W]*?)(&|$|#)/g
  var arrUrl = regRrl.exec(url)
  var ret = {}
  if (arrUrl && arrUrl[1]) {
    var strPara = arrUrl[1]
    var result = null
    while ((result = regPara.exec(strPara)) != null) {
      ret[decodeURIComponent(result[1])] = decodeURIComponent(result[2])
    }
  }
  return ret
}

export function parseUrl (url) {
  var parseUrl = /^[http:|https:]+\/\/([0-9.\-A-Za-z]+)(?::(\d+))?(\/[^?#]*)?/
  var result = parseUrl.exec(url)
  var resultObj = {
    host: result[1],
    port: result[2],
    path: result[3]
  }
  return resultObj
}
